import { ReactElement } from 'react';
import Switch from 'react-switch';
import { blue, concrete, red } from '../../styles';

export type UISwitchType = 'default' | 'default2';

export type UISwitchProps = {
    checked: boolean;
    onChange?: (checked: boolean) => void;
    small?: boolean;
    disabled?: boolean;
    type?: UISwitchType;
};
export function UISwitch(props: UISwitchProps): ReactElement {
    const { checked, onChange, small, disabled, type = 'default' } = props;

    const WIDTH = small ? 30 : 50;
    const BORDER = 2;

    return (
        <Switch
            checked={checked}
            onChange={(_checked) => {
                onChange?.(_checked);
            }}
            disabled={disabled}
            onColor={blue}
            offColor={type === 'default' ? red : concrete}
            uncheckedIcon={false}
            checkedIcon={false}
            handleDiameter={WIDTH / 2}
            height={WIDTH / 2 + BORDER * 2}
            width={WIDTH + BORDER * 2}
        />
    );
}
